// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnComplete,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { Session, UpdateSessionApiParameter } from "@insite/client-framework/Services/SessionService";
import {
    chain,
    LoadCart,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        fulfillmentMethod: "Ship" | "PickUp";
        properties: {
            quoteId: string;
        };
    } & HasOnComplete<void>,
    UpdateSessionApiParameter,
    Session
>;

interface CustomSession extends Session {
    properties: {
        quoteId: string;
    };
}

export const CustomPopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        session: {
            fulfillmentMethod: props.parameter.fulfillmentMethod,
            // XNG-Changes
            properties: {
                quoteId: props.parameter?.properties?.quoteId,
            },
        } as CustomSession,
    };
};

export const CustomLoadCart: HandlerType = async props => {
    if (getCurrentPage(props.getState()).type === "CheckoutShippingPage") {
        const cartId = props.getState().pages?.checkoutShipping?.cartId;
        cartId && props.dispatch(await loadCart({ cartId }));
    }
};

replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);
addToChainAfter(chain, LoadCart, CustomLoadCart);
